/* src/app/order/components/order-pricing/pricing-adjustments-details/pricing-adjustments-details.style.scss */
.label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 10px;
  display: flex;
}
.label span {
  vertical-align: middle !important;
}
.label-value {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #585858;
  margin-bottom: 5px;
}
.price-adjustments-details {
  display: flex;
  gap: 50px;
}
.price-adjustments-details .price-factors-part {
  min-width: 300px;
}
.daily-rates-header {
  color: #007d40;
}
.clickable-label {
  cursor: pointer;
  text-decoration: underline;
}
.fee-row {
  display: flex;
  justify-content: space-between;
  color: #585858;
  font-weight: bold;
  gap: 150px;
}
.fee-row .fee-amount {
  font-weight: bold;
  color: #007d40;
}
/*# sourceMappingURL=pricing-adjustments-details.style.css.map */
